// Función para obtener el variant del badge según el estado de la cuota
export const getInstallmentBadgeStatus = (statusType: string): string => {
  const statusMap: Record<string, string> = {
    'Vencida': 'danger',
    'Afrontada': 'warning',
    'Afrontada con pago parcial': 'warning',
    'Honrada': 'success',
    'Pendiente': 'neutral',
  };
  
  return statusMap[statusType] || 'neutral';
};
